export default "__VITE_PUBLIC_ASSET__71dece25__"